<template>
  <div class="border rounded">
    <table class="table table-sm table-hover w-100">
      <thead>
        <tr>
          <th class="text-center" colspan="2">
            Item
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-right w-35">
            <strong>Product:</strong>
          </td>
          <td class="text-left w-65">
            <router-link :to="{ name: 'EditProduct', params: { Id: order.productID } }">{{ order.prodName }}</router-link>
          </td>
        </tr>
        <tr v-if="order.pColor || order.psize">
          <td class="text-right w-35">
            <strong>Attributes:</strong>
          </td>
          <td class="text-left w-65">
            <i v-if="order.pColor">Color: {{ order.pColor }}</i
            >, <i v-if="order.psize">Size: {{ order.psize }}</i>
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>SKU:</strong>
          </td>
          <td class="text-left w-65">
            <p>{{ order.sku }}</p>
          </td>
        </tr>
        <!-- <tr>
        <td class="text-right w-35">
          <strong>Product Number:</strong>
        </td>
        <td class="text-left w-65">
          <p>{{ order.prodNumber }}</p>
        </td>
      </tr> -->
        <tr>
          <td class="text-right w-35">
            <strong>Quantity:</strong>
          </td>
          <td class="text-left w-65">
            <p>{{ order.quantity }}</p>
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong title="Customer currency cost per unit">Points per unit:</strong>
          </td>
          <td class="text-left w-65">
            <p>
              {{ order.productCost ? order.productCost : 0.0 }}
              Points
            </p>
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong title="Total Customer currency cost">Total points:</strong>
          </td>
          <td class="text-left w-65">
            <p>
              {{ order.productCost ? order.productCost * order.quantity : 0.0 }}
              Points
            </p>
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Wholesale cost per unit($):</strong>
          </td>
          <td class="text-left w-65">
            <p>
              ${{
                order.productWholeSale
                  ? order.productWholeSale.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : '0.00'
              }}
            </p>
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Shipping cost($):</strong>
          </td>
          <td class="text-left w-65">
            <p>
              ${{
                order.productShipping
                  ? order.productShipping.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : '0.00'
              }}
            </p>
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong title="Customer dollar equivalent cost:">Cost($):</strong>
          </td>
          <td class="text-left w-65">
            <p>
              ${{
                order.productCost
                  ? order.quantity*(order.productCost/order.ratio).toFixed(2)
                  : '0.00'
              }}
            </p>
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Sales tax($):</strong>
          </td>
          <td class="text-left w-65">
            <p>
              ${{ order.supplierSaleTax ? (order.supplierSaleTax/order.ratio).toFixed(2) : 0.0 }}
            </p>
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Income Tax/Order Tax($):</strong>
          </td>
          <td class="text-left w-65">
            <p>
              ${{
                order.taxPaymentDollars
                  ? order.quantity*order.taxPaymentDollars.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : '0.00'
              }}
            </p>
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Total inclusive of taxes($):</strong>
          </td>
          <td class="text-left w-65">
            <p>
              ${{
                order.productCost
                  ? ((order.supplierSaleTax/order.ratio) + (order.quantity*order.taxPaymentDollars) + (order.quantity*(order.productCost/order.ratio))).toFixed(2)
                  : '0.00'
              }}
            </p>
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Id:</strong>
          </td>
          <td class="text-left w-65">
            <p>{{ order.productId }}</p>
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Product Id:</strong>
          </td>
          <td class="text-left w-65">
            <router-link :to="{ name: 'EditProduct', params: { Id: order.productID } }">{{ order.productID }}</router-link>
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Supplier:</strong>
          </td>
          <td class="text-left w-65">
            <router-link :to="{ name: 'EditProduct', params: { Id: order.productID } }">{{ order.supplierName }}</router-link>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Item',
  computed: {
    order() {
      return this.$store.state.orderDetails.orderData;
    },
  },
};
</script>

<style lang="scss" scoped>
.w-100 {
  width: 100%;
}
.w-35 {
  width: 35%;
}
.w-65 {
  width: 65%;
}
table {
  margin-bottom: 0px;
  border: solid grey 0.5px;
}
td {
  border: solid grey 0.5px;
}
</style>
